import model from '../data/motivation-model.json';

export const analysisModel = model;
export const analysisConfigs = model.forms;
export const isReadinessForm = (key) => !!model.forms[key];
export function activeQuestions(key, answers = {}) {
  const config = model.forms[key];
  if (!config) return [];
  const time = config.questions[0];
  const index = time.options.findIndex((o) => o.label === answers[time.name]);
  return index === 0 || index === 1
    ? [time, { ...model.deadline, conditional: true }, ...config.questions.slice(1)]
    : config.questions;
}
export function missingReadinessQuestions(key, answers = {}) {
  return activeQuestions(key, answers).filter((q) => !q.options.some((o) => (typeof o === 'string' ? o : o.label) === answers[q.name]));
}
export function changeReadinessAnswer(key, answers, name, value) {
  const next = { ...answers, [name]: value };
  if (name === 'zaman_zorunlulugu' && !model.forms[key].questions[0].options.slice(0, 2).some((o) => o.label === value)) delete next.son_tarih;
  return next;
}
export function evaluateReadiness(key, answers = {}, allowIncomplete = false) {
  const config = model.forms[key];
  if (!config) return null;
  const missing = missingReadinessQuestions(key, answers);
  const questions = activeQuestions(key, answers);
  const selections = {};
  const responses = {};
  questions.forEach((q) => {
    if (q.options.some((o) => (typeof o === 'string' ? o : o.label) === answers[q.name])) {
      selections[q.name] = answers[q.name]; responses[q.label] = answers[q.name];
    }
  });
  const base = { model_version: model.version, selections, responses, completion: missing.length ? 'incomplete' : 'complete' };
  if (missing.length) return allowIncomplete ? { answers: { ...base, missing: missing.map((q) => q.label), group: null, blockers: [] }, score: null, category: 'Değerlendirilmedi', summary: 'Motivasyon soruları eksik yanıtlandığı için motivasyon puanı hesaplanmadı.' } : null;
  const indices = config.questions.map((q) => q.options.findIndex((o) => o.label === selections[q.name]));
  const raw = config.questions.reduce((total, q, i) => total + q.options[indices[i]].score, 0);
  const advice = [];
  const blockers = [];
  const recommendations = key === 'satici'
    ? ['Hedef tarihinizi işlem hazırlıklarıyla birlikte planlayın.', 'Satışla gerçekleştirmek istediğiniz hedefi belirleyin.', 'Fiyatınızı güncel piyasa verileri ve değerlemeyle karşılaştırın.', 'Teklifleri değerlendirecek karar planını hazırlayın.', 'Gösterim için düzenli randevu saatleri belirleyin.', 'Kiracı, evrak ve teslim koşullarını satış öncesinde netleştirin.', 'Satış kararınızı ve diğer karar vericilerin onayını kesinleştirin.', 'Piyasa analizi doğrultusunda fiyat beklentinizi yeniden değerlendirin.']
    : ['Hedef tarihinizi işlem hazırlıklarıyla birlikte planlayın.', 'Satın alımla gerçekleştirmek istediğiniz hedefi belirleyin.', 'Toplam bütçenizi ve ödeme sınırlarınızı belirleyin.', 'İnceleme ve teklif verme sürecinizi planlayın.', 'Yerinde inceleme için randevu saatleri belirleyin.', 'Finansmanınızı ve ödeme kaynağınızı kesinleştirin.', 'Satın alma kararınızı kesinleştirin.', 'Kriterlerinizi bütçe ve piyasa koşullarıyla karşılaştırın.'];
  indices.forEach((index, i) => {
    if (i > 0 && index >= 2) {
      const q = config.questions[i];
      advice.push({ question: q.label, answer: selections[q.name], text: recommendations[i] });
      if ([2, 3, 4, 5, 6, 7].includes(i)) blockers.push(recommendations[i]);
    }
  });
  const decisionReady = indices[6] === 0 && indices[1] <= 1;
  const score = Math.min(raw, blockers.length ? model.critical_cap : decisionReady ? 100 : 79);
  const ready = score >= model.ready_threshold && blockers.length === 0 && indices[6] === 0 && indices[1] <= 1;
  const deadlineIndex = model.deadline.options.indexOf(selections.son_tarih);
  const urgent = indices[0] <= 1 && deadlineIndex >= 0 && deadlineIndex <= 1 && indices[1] <= 1;
  const group = ready ? (urgent ? 'A+' : 'A') : (score >= 40 ? 'B' : 'C');
  const category = ready ? 'HAZIRSINIZ' : 'HAZIR DEĞİLSİNİZ';
  const summary = ready
    ? `Yanıtlarınız ${key === 'satici' ? 'satış' : 'satın alma'} kararınızın, piyasa yaklaşımınızın ve işlem hazırlığınızın uyumlu olduğunu gösteriyor. ${urgent ? 'Yakın hedef tarihiniz nedeniyle inceleme, finansman ve işlem adımlarını birlikte takvimlendirmek önem taşıyor.' : 'Acil bir zaman zorunluluğu olmadan da hazırlıklı ilerleyebilirsiniz. Uygun koşulları ve işlem adımlarını birlikte planlayabiliriz.'}`
    : `Yanıtlarınıza göre ${key === 'satici' ? 'satış' : 'satın alma'} sürecine geçmeden önce bazı hazırlıkları tamamlamanız yararlı olacaktır. ${blockers.length ? blockers.slice(0, 2).join(' ') : 'İşlem gerekçenizi, kararınızı ve önceliklerinizi birlikte değerlendirebiliriz.'} Bu değerlendirme, yanıtlarınıza dayalı bir hazırlık göstergesidir.`;
  return { answers: { ...base, raw_score: raw, final_score: score, applied_cap: blockers.length ? model.critical_cap : null, group, ready, urgent, blockers, advice }, score, category, summary };
}
